import axios from "axios";
import toast from "react-hot-toast";
import { env } from "../env";

// Axios Instance
const instance = axios.create({
  // eslint-disable-next-line no-undef
  baseURL: env.REACT_APP_DEV_BASE_URL || process.env.REACT_APP_DEV_BASE_URL
});

// Request interceptor
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token != null) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (!error.response) {
      toast.error("Network error");
      localStorage.removeItem("token");
      localStorage.removeItem("username");
    }
    if (error?.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.reload();
    } else {
      // toast.error(error.response.data.message);
    }

    return Promise.reject(error);
  }
);

export default instance;
